










import { Vue, Component, Prop } from 'vue-property-decorator'
@Component({
  name: 'content-layout'
})
export default class extends Vue {}
